import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Modalidad} from '../../../_models/modalidad';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ConfirmationService} from 'primeng/api';
import {ListaService} from '../../../_services/lista.service';
import {NavService} from '../../../_services/_nav.service';
import {ModalidadesFactorCrezcamosService} from '../../../_services/modalidades-factor-crezcamos.service';
import {ModalidadesFactorCrezcamos} from '../../../_models/modalidades-factor-crezcamos';
import {SelectItem} from 'primeng/api';
import {forkJoin} from 'rxjs';
import {ListaItem} from '../../../_models/lista-item';
import {ProductoPoliticaAlerta} from '../../../_models/producto-politica-alerta';
import {sleep} from '../../../utils/utilidades';
import {Producto} from '../../../_models/producto';

@Component({
  selector: 'app-modalidades-factor-crezcamos',
  templateUrl: './modalidades-factor-crezcamos.component.html',
  styleUrls: ['./modalidades-factor-crezcamos.component.css']
})
export class ModalidadesFactorCrezcamosComponent implements OnInit {
  @Input() modalidad: Modalidad;
  @Input() esDetalle: boolean = false;
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  // Lista
  listaModalidadesFactorCrezcamos: ModalidadesFactorCrezcamos [] = [];
  listasTiposObligacionesDataCreditoTodas: ListaItem[] = [];
  listasTiposObligacionesDataCredito: SelectItem[] = [];
  loading = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  loadingTabla = false;
  edit = false;
  registroEditar: ModalidadesFactorCrezcamos;
  constructor(private modalidadesFactorCrezcamosServicio: ModalidadesFactorCrezcamosService,
              private conServicio: ConfirmationService,
              private lisServicio: ListaService,
              private nav: NavService,
              private fb: FormBuilder) { }

 ngOnInit() {

    // Definiendo columnas datatable
    this.columnas = [
      {field: 'tipoObligacion', header: this.nav.buscarMensaje('MODALIDADES.LBL_MODALIDAD'), sort: false},
      {field: 'factorCrezcamos', header: this.nav.buscarMensaje('MODALIDADES.LBL_FACTOR'), sort: false},
      {field: 'habilitado', header: this.nav.buscarMensaje('MODALIDADES.LBL_HABILITADO'), sort: false},
    ];
    if (!this.esDetalle) {
      this.columnas.push(  {field: 'det', header: this.nav.buscarMensaje('LBL_ACCIONES'), sort: false});
    }

    forkJoin( this.modalidadesFactorCrezcamosServicio.obtenerPorIdModalidad(this.modalidad.idModalidad),
      this.lisServicio.getMasterDetails('ListasTiposObligacionesDataCredito')).subscribe(([listaModalidadesFactor, listaModalidadesBuro]) => {
      this.listaModalidadesFactorCrezcamos = listaModalidadesFactor;
      this.listasTiposObligacionesDataCreditoTodas = listaModalidadesBuro;

      this.cargarLista();
      this.cargarFormulario();
    }, error => {
      this.nav.setMesage( 4, {
        severity: 'error', summary: this.nav.buscarMensaje( 'LBL_ERROR' ),
        detail: this.nav.buscarMensaje( 'MODALIDADES.MSG_FACTORCREZCAMOS' )
      } );
      this.loading = false;
    });




  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idModalidad: [this.modalidad ? this.modalidad.idModalidad : null, [Validators.required]  ],
      factorCrezcamos: [null, [Validators.required]],
      idTipoObligacion: [ [],  [Validators.required]],
      indicadorHabilitado: [ false],
    });
    this.loading = false;
  }

 async agregar() {
    const _data = this.formulario.value;
    if ( this.formulario.valid ) {
      this.guardando = true;
      let indexReg = null;
      if (this.edit) {
          indexReg = this.listaModalidadesFactorCrezcamos.findIndex(c => c.idTipoObligacion ===  this.registroEditar.idTipoObligacion);
      }

      _data.idTipoObligacion.map( obligacion => {
        const temp = {} as ModalidadesFactorCrezcamos;
        temp.idModalidad = _data.idModalidad;
        temp.factorCrezcamos = _data.factorCrezcamos;
        temp.indicadorHabilitado = _data.indicadorHabilitado;
        const obligacionBuro = this.listasTiposObligacionesDataCreditoTodas.find( x => x.idLista === obligacion );
        if (obligacionBuro) {
          temp.tipoObligacion = obligacionBuro.nombre;
          temp.idTipoObligacion = obligacionBuro.idLista;

        }
        if (this.edit && this.registroEditar.idTipoObligacion === temp.idTipoObligacion) {
          if (indexReg >= 0) {
            this.listaModalidadesFactorCrezcamos[indexReg].factorCrezcamos = _data.factorCrezcamos;
            this.listaModalidadesFactorCrezcamos[indexReg].indicadorHabilitado = _data.indicadorHabilitado;
          }
        } else {
          this.listaModalidadesFactorCrezcamos.push(temp);
        }

      });
      if (this.edit) {
        const  _buscarReg = _data.idTipoObligacion.find(s => s === this.registroEditar.idTipoObligacion);
        if (!_buscarReg) {
          if (indexReg >= 0) {
            this.listaModalidadesFactorCrezcamos[indexReg].indicadorHabilitado = false;
          }
        }
      }
     this.ejecutarBulk();

    } else {
      this.submitted = true;
    }
  }

  ejecutarBulk() {
    this.modalidadesFactorCrezcamosServicio.bulk(this.listaModalidadesFactorCrezcamos).subscribe(async lista => {
      this.listaModalidadesFactorCrezcamos.forEach(d => {
        if (d.indicadorHabilitado) {
          const _buscarReg = lista.find(x => x.idModalidad === d.idModalidad && x.idTipoObligacion === d.idTipoObligacion );
          if (_buscarReg) {
            d.idModalidadFactorCrezcamos = _buscarReg.idModalidadFactorCrezcamos;
          }
        }
      });
      this.cargarFormulario();
      this.cargarLista();
      await sleep(100);
      this.guardando = false;
      this.nav.setMesage(1);
      this.submitted = false;
      this.registroEditar = null;
      this.edit = false;
    }, error => {
      this.guardando = false;
      this.nav.setMesage( 3 );
    });
  }

  cargarLista() {
    this.listasTiposObligacionesDataCredito = [];
    this.listasTiposObligacionesDataCreditoTodas.map( ( s: ListaItem ) => {
      if ( !this.listaModalidadesFactorCrezcamos.find( x => x.idTipoObligacion === s.idLista ) ) {
        this.listasTiposObligacionesDataCredito.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  editar(_dataEditar: any) {
    this.registroEditar = _dataEditar;
    const listaId = [];
    this.edit = true;
    const _reg = this.listasTiposObligacionesDataCreditoTodas.find(l => l.idLista === _dataEditar.idTipoObligacion);
    if (_reg) {
      this.listasTiposObligacionesDataCredito.push( { label: _reg.nombre, value: _reg.idLista } );
    }
    listaId.push(_dataEditar.idTipoObligacion);
    this.f.idTipoObligacion.setValue(listaId);
    this.f.factorCrezcamos.setValue(_dataEditar.factorCrezcamos);
    this.f.indicadorHabilitado.setValue(_dataEditar.indicadorHabilitado);


  }

  get f() {
    return this.formulario.controls;
  }

  cancelar(dirty: boolean) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'cancelar-edit',
        accept: () => {
          this.limpiar();
        },
        reject: () => {
        }
      } );
    } else {
      this.limpiar();
    }
  }

  limpiar() {
    this.registroEditar = null;
    this.edit = false;
    this.cargarFormulario();
    this.cargarLista();
    this.guardando = false;
    this.submitted = false;
  }


}
